import { useCallback } from 'react';

import { usePostHog } from 'posthog-js/react';

import { buildAnalyticsEvent } from '@/features/DataHub/modules/Export/services/ExportAnalyticsService';
import type { ExportSettingsType } from '@/features/DataHub/modules/Export/types/context.types';
import type { ExportOption } from '@/features/DataHub/modules/Export/types/exportConfig.types';
import { useAppSelector } from '@/hooks/redux-hooks';

const useExportAnalytics = (
  exportOption: ExportOption | null,
  exportSettings: ExportSettingsType
) => {
  const postHog = usePostHog();
  const symbols = useAppSelector(state => state.symbolSelector.symbols);

  const capturePosthogEvent = useCallback(() => {
    const { eventName, data } = buildAnalyticsEvent({ exportOption, symbols, exportSettings });
    postHog.capture(eventName, data);
  }, [exportOption, postHog, symbols, exportSettings]);

  return { capturePosthogEvent };
};

export default useExportAnalytics;
